import { z } from 'zod';

export const ApplicationTrackingSchema = z.object({
    id: z.string().optional(),
    applicationId: z.string().min(1),
    status: z.string().min(1),
    updatedBy: z.string().optional(),
    updatedAt: z.string().or(z.date()).optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateApplicationTrackingSchema = ApplicationTrackingSchema.omit({ id: true });
export const UpdateApplicationTrackingSchema = ApplicationTrackingSchema;